
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import numeral from 'numeral';
import { message } from 'ant-design-vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import CartIcon from '@/components/icons/CartIcon.vue';
import { getPartList, getPartPartsList } from '@/api/apis';
import { baseFileUrl } from '@/utils/constants';
import Banner from '@/components/banner/Banner.vue';
import MultiStatusModal from '@/components/multi-status/MultiStatusModal.vue';
import SingleStatusModal from '@/components/single-status/SingleStatusModal.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import AddPartToCartModal from '@/components/add-part-to-cart/AddPartToCartModal.vue';

interface PartDetailProps {
  columns: any[];
  dataSource: any[];
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'PartDetail',
  components: {
    EnlargeIcon,
    CartIcon,
    PreviewImageModal,
    MultiStatusModal,
    SingleStatusModal,
    AddPartToCartModal,
    Banner
  },
  data(): PartDetailProps {
    return {
      loading: false,
      colTitle: [
        'type',
        'photo',
        'name',
        'no',
        'code',
        'unit',
        'quantity',
        'uprice',
        'remark',
        'action'
      ],
      columns: [
        {
          dataIndex: 'groupName',
          width: 100,
          slots: { title: 'type-title', customRender: 'groupName' }
        },
        {
          dataIndex: 'partsImgs',
          slots: { customRender: 'photo', title: 'photo-title' },
          width: 100
        },
        {
          dataIndex: 'partName',
          width: 100,
          slots: { title: 'name-title', customRender: 'name' }
        },
        {
          dataIndex: 'modelNum',
          width: 100,
          slots: { title: 'no-title', customRender: 'modelNum' }
        },
        {
          dataIndex: 'partCode',
          width: 100,
          slots: { title: 'code-title' }
        },
        {
          dataIndex: 'unit',
          slots: { title: 'unit-title' },
          customRender: ({ text }) => {
            return this.$t(text);
          },
          width: 100
        },
        {
          dataIndex: 'quantity',
          width: 100,
          slots: { title: 'quantity-title', customRender: 'quantity' }
        },
        {
          dataIndex: 'sellingPrice',
          customRender: ({ text }) => {
            return text !== null ? numeral(text).format('$0.00') : '';
          },
          slots: { title: 'uprice-title' },
          width: 100
        },
        {
          dataIndex: 'remark',
          width: 100,
          slots: { title: 'remark-title' }
        },
        {
          key: 'action',
          slots: { customRender: 'action', title: 'action-title' },
          width: 100
        }
      ],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSizeOptions: ['10', '15', '20'],
        total: 0,
        showSizeChanger: true,
        pageSize: 10,
        showQuickJumper: true
      },
      vehicleId: null,

      previewImg: [],
      showPreviewModal: false,
      showSingleModal: false,
      showMultiModal: false,
      selectedRecord: {},

      showAddCartModal: false,
      addToCartRecord: {}
    };
  },
  created() {
    const route = useRoute();

    const params = route.params;

    if (params.vehicleId) {
      this.vehicleId = Number(params.vehicleId);
      this.loadData();
    }
  },
  methods: {
    getImg(partsImgs) {
      let res = '';

      const imgs = partsImgs || [];

      if (imgs.length > 0 && imgs[0].fileUrl) {
        res = baseFileUrl + imgs[0].fileUrl;
      }

      return res;
    },
    async loadData() {
      this.loading = true;
      const res = await getPartList({
        vehicleId: this.vehicleId,
        type: 3,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        regularStatus: 1 // 传1
      });

      if (res.success) {
        this.dataSource = res.result.records;
        this.ipagination.total = res.result.total;
      }

      this.loading = false;
    },
    // handleTableChange(pagination) {
    //   this.ipagination = pagination;
    //   this.loadData();
    // },
    onShowSizeChange(current) {
      this.ipagination.current = current;

      this.loadData();
    },
    onChange(page, pageSize) {
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;

      this.loadData();
    },
    handleAddToCart(record) {
      if (record.addedToCart) {
        message.error(this.$t('single_status.already_added'));
        return;
      }
      this.selectedRecord = record;
      if (record.differentStatus === 0) {
        this.showSingleModal = true;
      } else {
        this.showMultiModal = true;
      }
    },
    handlePreviewImg(record) {
      // const img = this.getImg(record.partsImgs);

      this.previewImg.push(
        ...(record.partsImgs || [])
          .filter(s => s.fileUrl)
          .map(s => baseFileUrl + s.fileUrl)
      );

      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    handleAfterSingleClose(addedToCart) {
      this.selectedRecord.addedToCart = addedToCart;
      this.showSingleModal = false;
    },
    handleAfterMultiClose(data, isCancel) {
      if (!isCancel) {
        this.addToCartRecord = data;
        this.showAddCartModal = true;
      }
      this.showMultiModal = false;
    },
    handleAfterAddCartClose(isCancel) {
      if (!isCancel) {
        const item = this.dataSource.find(
          s => s.modelNum === this.addToCartRecord.modelNum
        );

        if (item) {
          item.addedToCart = true;
        }

        this.dataSource = [...this.dataSource];
      }
      this.showAddCartModal = false;
    },
    async handleRedirect(modelNum) {
      modelNum = modelNum ? modelNum.trim() : '';
      const res = await getPartPartsList({
        modelNum: modelNum
      });
      if (res.success) {
        const data = res.result || {};
        const hasResult = data.total >= 2;
        if (data.total === 1) {
          window.open(
            `/part-detail/${data.records[0].id}?modelNum=${modelNum}`
          );
        } else {
          window.open(
            `/part-result?isNo=1&modelNum=${modelNum}&hasResult=${Number(
              hasResult
            )}`
          );
        }
      }
    }
  }
});
